import { PageLayout } from "../../shared/layouts/PageLayout";
import { useParams } from "react-router";
import { adminDashboardBreadcrumbs } from "../../features/AdminDashboard/admin-dashboard-breadcrumbs";
import { useGetUser } from "../../queries/users/useGetUser";
import { ManageUser } from "@features/Users/ManageUser";

export function ManageUserPage() {
  const { userId = "" } = useParams<{
    userId: string;
  }>();
  const userQuery = useGetUser({
    id: userId,
  });
  const user = userQuery.data;

  const breadcrumbs = {
    current: {
      label: "Edit",
    },
    previous: [
      adminDashboardBreadcrumbs.dashboard,
      adminDashboardBreadcrumbs.users,
      {
        label: user?.name || user?.email || "",
        link: `/admin/users/${userId}`,
      },
    ],
  };

  return (
    <PageLayout breadcrumbs={breadcrumbs}>
      <ManageUser userId={userId} />
    </PageLayout>
  );
}
